<template>
    <button @click.prevent="checkIsPending($event)" :class="{[className]: true, disabled: isPending}">
        <span v-if="isPending">
            <i class="fas fa-pulse fa-spinner"></i>
        </span>
        <slot></slot>
    </button>
</template>
<script>
    export default {
        props: ['className', 'isPending'],
        methods: {
            checkIsPending(event) {
                if (this.isPending) {
                    event.stopPropagation();
                    event.preventDefault();
                    return false;
                } else {
                    this.$emit('click', event);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/spinner-button.vue